interface VideoProps {
  rootEl: HTMLVideoElement;
}

const Video = (props: VideoProps) => {
  props.rootEl.addEventListener("play", () => {
    props.rootEl.setAttribute("controls", "controls");
  });

  props.rootEl.addEventListener("pause", () => {
    props.rootEl.removeAttribute("controls");
  });

  props.rootEl.addEventListener("click", () => {
    if (props.rootEl.paused) {
      props.rootEl.play();
    }
  });
};

const init = () => {
  const videos = document.querySelectorAll<HTMLVideoElement>("[h-comp='video']");

  for (const video of videos) {
    Video({ rootEl: video });
  }
};

init();
